import React from "react"
import AdfoxAdaptive from "components/AdFoxAdaptive"


export function AdfoxBlock({isFull, isDesktop, options}) {
    if (!options) {
        return null
    }

    const option = isFull ? (isDesktop ? options.fullPc : options.fullMob) : (isDesktop ? options.prevPc : options.prevMob)

    if (!option) {
        return null;
    }

    return <AdfoxAdaptive options={option}/>
}
